export default __webpack_public_path__ + "static/media/whatMentalHealth.ee7ea087.jpg";